import { UserPermissionCodes } from "@odata/CompanyPermissionEnums";
import { EntityTypeName } from "@odata/GeneratedEntityTypes";
import React, { lazy } from "react";

import { ROUTE_DELETE_LOG, ROUTE_MESSAGES } from "../routes";
import FormRoute from "../routes/FormRoute";

const Messages = lazy(() => import(/* webpackChunkName: "audit" */"@pages/messages/Messages"));
const DeleteLog = lazy(() => import(/* webpackChunkName: "audit" */"@pages/deletedItems/DeleteLog"));

export default function auditBundle(): React.ReactElement[] {
    return [
        <FormRoute path={ROUTE_MESSAGES}
                   key={ROUTE_MESSAGES}
                   CPs={UserPermissionCodes.Audit}
                   entityType={EntityTypeName.CommunicationEntry}
                   page={Messages}/>,
        <FormRoute
                path={ROUTE_DELETE_LOG}
                key={ROUTE_DELETE_LOG}
                CPs={UserPermissionCodes.Audit}
                entityType={EntityTypeName.DocumentDeleteLog}
                page={DeleteLog}/>
    ];
}